/* Progressive enhancement: every player is a working YouTube link without JS. */
(() => {
  function init(root) {
    if (!root || root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    const videoId = root.dataset.videoId;
    if (!/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
    const slots = new Map();
    root.querySelectorAll('[data-video-slot]').forEach(slot => slots.set(slot, slot.innerHTML));
    let activeSlot = null;
    let stopButton = null;
    const status = root.querySelector('[data-video-status]');
    function stop(focus) {
      if (!activeSlot) return;
      const slot = activeSlot;
      slot.innerHTML = slots.get(slot);
      stopButton?.remove();
      activeSlot = null;
      stopButton = null;
      if (focus) slot.querySelector('a')?.focus();
    }
    function play(link, autoplay) {
      const slot = link.closest('[data-video-slot]');
      const start = Math.max(0, Number(link.dataset.videoStart) || 0);
      const end = Number(link.dataset.videoEnd) || 0;
      const title = link.dataset.videoTitle;
      stop(false);
      const url = new URL(`https://www.youtube-nocookie.com/embed/${videoId}`);
      url.search = new URLSearchParams({start, autoplay: autoplay ? '1' : '0', playsinline: '1', rel: '0'}).toString();
      if (end > start) url.searchParams.set('end', end);
      const frame = document.createElement('iframe');
      frame.src = url.href;
      frame.title = title;
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      slot.replaceChildren(frame);
      activeSlot = slot;
      stopButton = document.createElement('button');
      stopButton.type = 'button';
      stopButton.className = 'wv-faq__stop';
      stopButton.textContent = 'Close video';
      stopButton.addEventListener('click', () => stop(true));
      slot.after(stopButton);
      status.textContent = `${title}. Video loaded at ${start} seconds.`;
      if (autoplay) frame.focus();
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-video-start]');
      if (!link || !root.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      play(link, true);
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && activeSlot) stop(true);
    });
    // Clip URLs work on arrival without unexpectedly autoplaying audio.
    const t = new URLSearchParams(location.search).get('t');
    if (t !== null && /^\d+$/.test(t)) {
      const link = [...root.querySelectorAll('[data-video-start]')].find(a => Number(a.dataset.videoStart) === Number(t));
      if (link) {
        play(link, false);
        requestAnimationFrame(() => {
          (activeSlot.closest('.wv-faq__chapter') || activeSlot).scrollIntoView({block: 'start'});
        });
      }
    }
    const hashTarget = document.getElementById(location.hash.slice(1));
    if (hashTarget?.matches('.wv-faq__item')) hashTarget.open = true;
  }
  document.querySelectorAll('[data-video-faq]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-video-faq]')));
})();
